export default __webpack_public_path__ + "static/media/advanced-web.5a4203be.png";